import { lazy } from 'react';

export const DataCenterMain = lazy(() => import('./DataCenterMain.component'));
